const accordions = document.querySelectorAll(".precision-accordion");
const more = document.querySelector(".more");
const offerBtn = document.querySelector(".offer-btn");
const contactSales = document.querySelector(".contact-sales");
const popup = document.querySelector(".popup-form");
const closebtn = document.querySelector(".close-btn");

// move them to <body> so they're not constrained by .body-law
document.body.appendChild(more);
document.body.appendChild(popup);

more.addEventListener("click", function () {
  popup.style.display = "flex";
});
offerBtn.addEventListener("click", function () {
  popup.style.display = "flex";
});
contactSales.addEventListener("click", function () {
  popup.style.display = "flex";
});
closebtn.addEventListener("click", function () {
  popup.style.display = "none";
});



accordions.forEach(acc => {
  acc.addEventListener("click", function () {
    const panel = this.nextElementSibling;
    const icon = this.querySelector(".arrow");

    // Close all panels and reset icons
    accordions.forEach(otherAcc => {
      const otherPanel = otherAcc.nextElementSibling;
      const otherIcon = otherAcc.querySelector(".arrow");

      if (otherAcc !== this) {
        otherPanel.style.maxHeight = null;
        otherIcon.classList.remove("fa-chevron-down");
        otherIcon.classList.add("fa-chevron-up");
        otherAcc.classList.remove("active");
      }
    });

    // Toggle the clicked panel and icon
    const isActive = this.classList.toggle("active");
    if (isActive) {
      panel.style.maxHeight = panel.scrollHeight + "px";
      icon.classList.remove("fa-chevron-up");
      icon.classList.add("fa-chevron-down");
    } else {
      panel.style.maxHeight = null;
      icon.classList.remove("fa-chevron-down");
      icon.classList.add("fa-chevron-up");
    }
  });
});

// slider script
let current = 0;
const slides = document.querySelectorAll('.slide');

function showNextSlide() {
  slides[current].classList.remove('active');
  current = (current + 1) % slides.length;
  slides[current].classList.add('active');
}

setInterval(showNextSlide, 3000); // Change every 3 seconds



// Initialize calculation script 

document.getElementById("count").addEventListener("input", function (e) {
  if (e.target.value < 0) {
      e.target.value = 0; // Reset to 1 if the value is less than 1
  }
});
  
    const countField = document.getElementById('count');


    countField.addEventListener('input', function(){
      const count = document.getElementById("count").value;
      const frequency = parseFloat(document.getElementById("frequency").value);
      const nursetime = parseFloat(document.getElementById("nursetime").value);
      const hrhour = parseFloat(document.getElementById("hrhour").value);
      const hroffice = parseFloat(document.getElementById("hroffice").value);
      const nursehour = parseFloat(document.getElementById("nursehour").value);
      if (count == 1) {
    waggonerValue ="29.50";
} else if (count >= 100000) {
  waggonerValue = "2.00";
} else if (count >= 80000) {
    waggonerValue = "2.30";
} else if (count >= 60000) {
    waggonerValue = "2.95";
} else if (count >= 40000) {
    waggonerValue = "3.69";
} else if (count >= 20000) {
    waggonerValue = "4.43";
} else if (count >= 10000) {
    waggonerValue = "5.16";
} else if (count >= 7500) {
    waggonerValue = "5.90";
} else if (count >= 5000) {
    waggonerValue = "6.64";
} else if (count >= 2500) {
    waggonerValue = "7.38";
} else if (count >= 1000) {
    waggonerValue = "8.11";
} else if (count >= 750) {
    waggonerValue = "8.85";
} else if (count >= 500) {
    waggonerValue = "11.80";
} else if (count >= 250) {
    waggonerValue = "14.75";
} else if (count >= 100) {
    waggonerValue = "17.70";
} else if (count >= 50) {
    waggonerValue = "20.65";
} else if (count >= 25) {
    waggonerValue = "23.60";
} else if (count >= 10) {
    waggonerValue = "26.55";
}
console.log(count == 1);
document.getElementById("waggonerResult").innerText = `$${waggonerValue}`
document.getElementById("traditionalEmployeeCount").innerText = `${count}`
document.getElementById("waggonerEmployeeCount").innerText = `${count}`

const newWaggonerValue = waggonerValue;

const cuurentHRTimeCost = (30 / 60) * hrhour * count;
const newHRTimeCost = (5 / 60) * hrhour * count;
const cuurentNursesTimeCost = (30 / 60) * nursehour * count;
const newNursesTimeCost = (10 / 60) * nursehour * count;
const fixedCost = 200;
const VariableCost = (waggonerValue) * count;
const currentProcessCost = (cuurentHRTimeCost + cuurentNursesTimeCost + fixedCost).toFixed(2);
const newProcessCost = (newHRTimeCost + newNursesTimeCost + VariableCost).toFixed(2);
const costSaving = (currentProcessCost - newProcessCost).toFixed(2);

 
 document.getElementById("totalCurrentProcessCost").innerText = `$${currentProcessCost}`;
 document.getElementById("totalNewProcessCost").innerText = `$${newProcessCost}`;
 if(newProcessCost == 0){
  document.getElementById("totalSaving").innerText = `$0.00`;
 } else{
  document.getElementById("totalSaving").innerText = `$${costSaving}`;
 }
 

    })

// client carousel script
const clientTrack = document.getElementById('clientCarouselTrack');
const clientDotsContainer = document.getElementById('clientDots');
const clientImages = clientTrack.querySelectorAll('img');
const imagesPerSlide = 5;
const totalSlides = Math.ceil(clientImages.length / imagesPerSlide);
let clientIndex = 0;
let clientInterval;

// Create dots
for (let i = 0; i < totalSlides; i++) {
  const dot = document.createElement('span');
  dot.classList.add('client-dot');
  if (i === 0) dot.classList.add('active');
  dot.addEventListener('click', () => {
    clientIndex = i * imagesPerSlide;
    moveClientCarousel();
    resetClientAutoplay();
  });
  clientDotsContainer.appendChild(dot);
}

const clientDots = document.querySelectorAll('.client-dot');

function moveClientCarousel() {
  const imageWidth = clientImages[0].offsetWidth + 20; // image + margin
  const totalWidth = imageWidth * clientImages.length;
  const visibleWidth = imageWidth * imagesPerSlide;
  const maxTranslate = totalWidth - visibleWidth;
  const translateX = Math.min(clientIndex * imageWidth, maxTranslate);

  clientTrack.style.transform = `translateX(-${translateX}px)`;

  // Update active dot
  const activeDotIndex = Math.floor(clientIndex / imagesPerSlide);
  clientDots.forEach(dot => dot.classList.remove('active'));
  if (clientDots[activeDotIndex])
    clientDots[activeDotIndex].classList.add('active');
}

// Autoplay (one image at a time)
function startClientAutoplay() {
  clientInterval = setInterval(() => {
    clientIndex++;
    if (clientIndex > clientImages.length - imagesPerSlide) {
      clientIndex = 0;
    }
    moveClientCarousel();
  }, 2000);
}

function resetClientAutoplay() {
  clearInterval(clientInterval);
  startClientAutoplay();
}

startClientAutoplay();

// Pause on hover
clientTrack.addEventListener('mouseenter', () => clearInterval(clientInterval));
clientTrack.addEventListener('mouseleave', () => startClientAutoplay());
